define([
	"dojo/_base/declare",
	"underscore",
	"csi/locale",
	"csi/reflection",
	"csi/store/Names",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare,_,locale,reflection,Names,MultiSelectSwitchboard) {


	return declare(MultiSelectSwitchboard, {
		idViewProperty: "selectedResponses",
		disableButtonAction: true,
		refreshStoreOptions: true,
		switchboardPath: "Child:SupplierSpecResponseRevs",
		hideGo: true,
		bDelayInitialization: true,
		depPathsLoaded: false,

		onRefresh: function() {
			this.depPathsLoaded = true;
		},

		/**
		 * @override
		 * Show the name of the master rather than the revision in drop down
		 */
		_getStoreOptions: function(url, r) {
			var options = this.inherited(arguments);
			var view = this.getView();
			var ctx = view.getContext();

			if (options.data) {
				_.forEach(options.data, function (d) {
					const responseUrl = ctx.cache.getNode(d[Names.ID_PROPERTY]).Master;
					const responseNode = ctx.cache.getNode(responseUrl);
					d[Names.NAME_PROPERTY] = locale.getNodeName(responseNode, ctx.cache);
				}, this);
				if (this.depPathsLoaded) {
					options.data = _.filter(options.data, function (d) {
						const responseRevNode = ctx.cache.getNode(d[Names.ID_PROPERTY]);
						const supplierNode = ctx.cache.getPathNode(responseRevNode, "Child:Master/Child:__Parent__/Child:Supplier");
						return supplierNode;
					}, this);
				}
			} else if (options.request) {
				options.request.addParameter("Qry.Value.Path", reflection.PATH_PARENT);
			}
			return options;
		},

		/**
		 * @override
		 * Add NONE and ALL option to select widget
		 */
		onSelectParams: function(params) {
			params.defaultClearText = "SelectNone";
			params.addItemAll = true;
		},

		/**
		 * @override
		 * Don't show the switchboard if SupplierSpecResponses is empty
		 */
		canShowPlugin: function() {
			const view = this.getView();
			const revision = view.getViewNode();
			const responseUrls = revision && revision.SupplierSpecResponseRevs;
			return !_.isEmpty(responseUrls);
		}
	});
});